export default __webpack_public_path__ + "static/media/24.0143871a.png";